<div class="avs-user-data mt-4">
  <div class="row justify-content-center d-flex avs-user-data-container">
    <div class="col-12 col-lg-5">
      <div>
        <h5>Profilinformationen</h5>
        <p>Passen Sie Ihre Profilinformationen und E-Mail-Adresse an.</p>
      </div>
    </div>
    <div class="col-12 col-lg-7 mb-5">
      <div class="card rounded-0 shadow h-100">
        <div *ngIf="userData" class="w-75 p-3">
          <div class="mb-3">
            <avs-text-input label="Titel" [value]="userData.title"
              (valueChange)="onTitleValueChange($event)"></avs-text-input>
          </div>
          <div class="mb-3">
            <avs-text-input label="Vorname" [value]="userData.firstName"
              (valueChange)="onFirstNameValueChange($event)"></avs-text-input>
          </div>
          <div class="mb-3">
            <avs-text-input label="Name" [value]="userData.lastName"
              (valueChange)="onLastNameValueChange($event)"></avs-text-input>
          </div>
          <div class="mb-3">
            <avs-text-input label="E-Mail" [value]="userData.email"
              (valueChange)="onEmailValueChange($event)"></avs-text-input>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="userData.isAuthorizedForAlarms">
            <div>
              <mat-slide-toggle [(ngModel)]="userData.isAlarmsActivated">Alarm aktiviert:
                {{ userData.isAlarmsActivated ? 'Ja' : 'Nein' }}</mat-slide-toggle>
            </div>
            <div>
              <mat-slide-toggle [disabled]="!userData.isAlarmsActivated"
                [(ngModel)]="userData.isAcousticAlarmsActivated">Akustischer Alarm aktiviert:
                {{ userData.isAcousticAlarmsActivated ? 'Ja' : 'Nein' }}</mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="bg-light w-100 p-3 text-end">
          <button type="button" class="btn btn-primary ms-0 avs-user-data-button rounded-0 border-0 shadow"
            (click)="onSaveUserDataBtnClicked()">Speichern</button><br>
        </div>
      </div>
    </div>
    <hr>
  </div>

  <div class="row justify-content-center d-flex mt-4 avs-user-data-container mb-5">
    <div class="col-12 col-lg-5">
      <div>
        <h5>Passwort anpassen</h5>
        <p>Stellen Sie sicher, dass Ihr Account ein langes, zufälliges und sicheres Passwort benutzt.</p>
      </div>
    </div>
    <div class="col-12 col-lg-7 mb-5">
      <div class="card rounded-0 shadow h-100">
        <div class="w-75 p-3">
          <div class="mb-3">
            <avs-text-input label="Altes Passwort" type="password" [required]="true" [value]="passwordData.oldPassword"
              (valueChange)="onOldPasswordChange($event)"></avs-text-input>
          </div>
          <div class="mb-3">
            <avs-password-confirm-input (passwordChange)="onNewPasswordChange($event)"></avs-password-confirm-input>
          </div>
        </div>
        <div class="bg-light w-100 p-3 text-end">
          <button type="button" class="btn btn-primary ms-0 avs-user-data-button rounded-0 border-0 shadow"
            (click)="onSaveNewPasswordBtnClicked()">Speichern</button><br>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center d-flex mt-4 avs-user-data-container mb-5">
    <div class="col-12 col-lg-5">
      <div>
        <h5>Zwei-Faktor-Authentifizierung</h5>
        <p>Schützen Sie Ihr Konto mit einem zusätzlichen Sicherheitscode beim Anmelden.</p>
      </div>
    </div>
    <div class="col-12 col-lg-7 mb-5">
      <div class="card rounded-0 shadow h-100">
        <div class="p-4 two-factor-card-body">
          <div class="two-factor-status mb-4">
            <span class="two-factor-status__badge" [class.two-factor-status__badge--active]="isTwoFactorEnabled">
              {{ isTwoFactorEnabled ? '2FA aktiv' : '2FA nicht aktiv' }}
            </span>
            <p class="text-secondary mb-0 mt-2">
              {{ isTwoFactorEnabled
                ? 'Ihr Konto verlangt beim Anmelden zusätzlich einen Code aus Ihrer Authenticator-App.'
                : 'Richten Sie jetzt eine Authenticator-App ein, um den Login zusätzlich abzusichern.' }}
            </p>
          </div>

          <div *ngIf="authenticatorSetup && !isTwoFactorEnabled" class="two-factor-setup row g-4 align-items-start">
            <div class="col-12 col-xl-5 text-center">
              <div class="two-factor-qr-wrapper" *ngIf="authenticatorQrCodeDataUrl; else manualSetupHint">
                <img [src]="authenticatorQrCodeDataUrl" alt="QR-Code für Authenticator-Setup" class="img-fluid two-factor-qr-image">
              </div>
              <ng-template #manualSetupHint>
                <div class="two-factor-manual-hint text-secondary">
                  Der QR-Code konnte nicht erzeugt werden. Verwenden Sie bitte den Secret Key für die manuelle Einrichtung.
                </div>
              </ng-template>
            </div>

            <div class="col-12 col-xl-7">
              <h6 class="mb-3">Authenticator-App einrichten</h6>
              <ol class="two-factor-steps mb-4">
                <li>Öffnen Sie Ihre Authenticator-App und fügen Sie ein neues Konto hinzu.</li>
                <li>Scannen Sie den QR-Code oder tragen Sie den Secret Key manuell ein.</li>
                <li>Geben Sie anschließend den angezeigten 6-stelligen Code unten ein.</li>
              </ol>

              <div class="two-factor-secret mb-3" *ngIf="authenticatorSetup.secretKey">
                <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                  <div>
                    <div class="text-secondary small">Secret Key</div>
                    <div class="two-factor-secret__value">{{ authenticatorSetup.secretKey }}</div>
                  </div>
                  <button type="button" class="btn btn-outline-secondary rounded-0" (click)="onCopySecretKeyClicked()">
                    Key kopieren
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <avs-text-input label="Bestätigungscode" [value]="twoFactorSetupCode"
                  (valueChange)="onTwoFactorCodeChange($event)"></avs-text-input>
              </div>

              <p class="text-secondary mb-0">Nach der Bestätigung wird 2FA sofort für Ihren nächsten Login aktiviert.</p>
            </div>
          </div>

          <div *ngIf="isTwoFactorEnabled" class="two-factor-active-note text-secondary">
            {{ userData?.isTwoFactorRequired
              ? 'Die Zwei-Faktor-Authentifizierung ist aktiv und für Ihr Konto für die Anmeldung verpflichtend. Sie können sie nicht dauerhaft deaktivieren.'
              : 'Die Zwei-Faktor-Authentifizierung ist aktiv.' }}
          </div>
        </div>

        <div class="bg-light w-100 p-3 text-end">
          <button type="button" class="btn btn-outline-secondary rounded-0 me-2"
            *ngIf="isTwoFactorEnabled" [disabled]="isTwoFactorBusy" (click)="onTwoFactorDisableClicked()">
            {{ userData?.isTwoFactorRequired ? 'Aktuelles 2FA Setup deaktivieren' : '2FA deaktivieren' }}
          </button>
          <button type="button" class="btn btn-secondary rounded-0 me-2"
            *ngIf="authenticatorSetup && !isTwoFactorEnabled" [disabled]="isTwoFactorBusy || !twoFactorSetupCode.trim()"
            (click)="onConfirmTwoFactorSetupClicked()">
            2FA bestätigen
          </button>
          <button type="button" class="btn btn-primary ms-0 avs-user-data-button rounded-0 border-0 shadow"
            *ngIf="!isTwoFactorEnabled" [disabled]="isTwoFactorBusy" (click)="onTwoFactorSetupClicked()">
            {{ isTwoFactorBusy ? 'Lädt...' : (authenticatorSetup ? 'Setup neu laden' : '2FA einrichten') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center d-flex mt-4 avs-user-data-container mb-5">
    <div class="col-12 col-lg-5">
      <div>
        <h5>Datenschutz</h5>
        <p>Verwalten Sie Ihre Zustimmung zur Datenschutzerklärung.</p>
      </div>
    </div>
    <div class="col-12 col-lg-7 mb-5">
      <div class="card rounded-0 shadow h-100">
        <div class="p-4">
          <p class="text-secondary mb-0" *ngIf="userData?.acceptTerms; else noConsent">
            Sie haben der Datenschutzerklärung zugestimmt. Beim Widerruf werden Sie abgemeldet
            und müssen beim nächsten Login erneut zustimmen.
          </p>
          <ng-template #noConsent>
            <p class="text-secondary mb-0">Es liegt aktuell keine Zustimmung vor.</p>
          </ng-template>
        </div>
        <div class="bg-light w-100 p-3 text-end" *ngIf="userData?.acceptTerms">
          <button type="button" class="btn btn-outline-danger rounded-0" (click)="onRevokeTermsClicked()">
            Zustimmung widerrufen
          </button>
        </div>
      </div>
    </div>
  </div>
</div>